import { format, isValid, parse } from 'date-fns';

/** ISO yyyy-MM-dd → отображение dd.MM.yyyy для инпута */
export function projectReviewDeadlineToDisplay(iso: string | null | undefined): string {
  if (!iso || !String(iso).trim()) return '';
  try {
    const d = parse(String(iso).trim(), 'yyyy-MM-dd', new Date());
    return isValid(d) ? format(d, 'dd.MM.yyyy') : String(iso).trim();
  } catch {
    return String(iso).trim();
  }
}

/** Отображение dd.MM.yyyy → API yyyy-MM-dd */
export function reviewDeadlineDisplayToApi(display: string): string | null {
  const t = display.trim();
  if (!t) return null;
  try {
    const d = parse(t, 'dd.MM.yyyy', new Date());
    return isValid(d) ? format(d, 'yyyy-MM-dd') : null;
  } catch {
    return null;
  }
}
